import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconEyeSlashSvg } from "./IconEyeSlashSvg.mjs";
const IconEyeSlash = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconEyeSlashSvg, ...iconProps });
};
export {
  IconEyeSlash
};
